var _path, _path2, _path3, _rect, _path4, _rect2, _polygon, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrj2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2880 1600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2196.49,32h-366.09c-39.56,0-71.94,10.63-71.94,23.61v554.5c0,12.99,32.37,23.61,71.94,23.61h366.09c39.56,0,71.94-10.63,71.94-23.61V55.61c0-12.99-32.37-23.61-71.94-23.61ZM2035.59,452.14c0,2.58-6.44,4.7-14.31,4.7h-15.66c-7.87,0-14.31-2.11-14.31-4.7v-238.55c0-2.58,6.44-4.7,14.31-4.7h15.66c7.87,0,14.31,2.11,14.31,4.7v238.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.25,1565.39h317.06s0-931.04,0-931.04h-226.48s0,843.19,0,843.19h-90.58s0,87.84,0,87.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M481.15,634.35H106.31c-40.51,0-73.65,10.13-73.65,22.5v528.44c0,12.38,33.14,22.5,73.65,22.5h374.84c40.51,0,73.65-10.13,73.65-22.5v-528.44c0-12.38-33.14-22.5-73.65-22.5ZM316.4,1034.74c0,2.46-6.59,4.48-14.65,4.48h-16.04c-8.06,0-14.65-2.01-14.65-4.48v-227.34c0-2.46,6.59-4.48,14.65-4.48h16.04c8.06,0,14.65,2.01,14.65,4.48v227.34Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1110.14,
    width: 239.06,
    height: 456
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M941.29,633.73h-307.06c-33.18,0-60.34,10.13-60.34,22.5v528.36c0,12.38,27.15,22.5,60.34,22.5h307.06c33.18,0,60.34-10.13,60.34-22.5v-528.36c0-12.38-27.15-22.5-60.34-22.5ZM806.33,1034.06c0,2.46-5.4,4.48-12,4.48h-13.14c-6.6,0-12-2.01-12-4.48v-227.31c0-2.46,5.4-4.48,12-4.48h13.14c6.6,0,12,2.01,12,4.48v227.31Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 573.9,
    y: 1051.34,
    width: 182.3,
    height: 514.05
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1001.63 1566.14 819.33 1566.14 715.74 1207.85 898.03 1207.85 1001.63 1566.14"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1019.25,
    y: 633.73,
    width: 385.56,
    height: 87.84
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1422.43,
    y: 1340.76,
    width: 227.24,
    height: 227.24
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2296.14,
    y: 32,
    width: 551.86,
    height: 196.38
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2296.14,
    y: 437.34,
    width: 551.86,
    height: 196.38
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2296.14,
    y: 234.67,
    width: 551.86,
    height: 196.38
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2552.13,
    y: 32,
    width: 295.87,
    height: 396.92
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2296.14,
    y: 234.67,
    width: 295.87,
    height: 399.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrj2);
export default __webpack_public_path__ + "static/media/prj_2.57273d83f8cbf744d805a42c6e61f1f5.svg";
export { ForwardRef as ReactComponent };